import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  color: #000;
  background-color: #F2F2F2;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  padding: 100px;
  width: 80%;
  margin: 0 auto;
  gap: 50px;
  max-width: 1500px;
`;

export const ContactDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Logo = styled.div`
  width: 300px;
  height: 300px;
  border-radius: 50%;
`;

export const Info = styled.div`
  p:nth-child(1){
    font-size: 1.2em;
    font-weight: bold;
    text-transform: uppercase;
  }

  font-size: 0.9rem;
`;

export const SocialIcons = styled.div`
  font-size: 1.3em;
  display: flex;
  gap: 10px;
`;

export const Icon = styled.div`
  font-size: 1.5rem;
  cursor: pointer;
`;

export const Form = styled.form`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const InputRow = styled.div`
  display: flex;
  gap: 20px;
`;

export const InputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-weight: bold;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  padding: 15px 20px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  background-color: #E7E7E7;
`;

export const TextArea = styled.textarea`
  padding: 15px 20px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  min-height: 100px;
  border-radius: 30px;
  background-color: #E7E7E7;
`;

export const SubmitButton = styled.button`
  align-self: flex-end;
  background-color: rgba(40, 44, 52, 1);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(40, 44, 52, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
  }
`;